import { __assign } from "tslib";
var MAVENOID_API_BASE_API_CONFIG = {
    scopes: [],
};
export var getMavenoidApiConfig = function () {
    return MAVENOID_API_BASE_API_CONFIG;
};
export var setMavenoidApiConfig = function (config) {
    MAVENOID_API_BASE_API_CONFIG = __assign({}, config);
};
